// extracted by mini-css-extract-plugin
module.exports = {"confirmButton":"deleteSchema_confirmButton__18-qH","cancelButton":"deleteSchema_cancelButton__DF52o","buttonsContainer":"deleteSchema_buttonsContainer__14T0S"};